import { Stack, Typography } from "@mui/material"
import { motion } from "framer-motion"
import React from "react"

import { Dexi } from "./Dexi"
import { Botega } from "../create-agent-anim/Botega"
import { BotegaFlow } from "../create-agent-anim/BotegaFlow"

export type CreateAgentStage = "creating"

const STAGE_TITLES: Record<CreateAgentStage, string> = {
  creating: "Creating Botega Pool",
}

const STAGE_PROGRESS: Record<CreateAgentStage, number> = {
  creating: 100,
}

export function CreatePoolAnimation() {
  const stage = "creating"

  return (
    <>
      <Stack width="fit-content" gap={0.5} alignItems="center">
        <Stack
          direction="row"
          alignItems="center"
          component={motion.div}
          initial="rest"
          animate={stage}
        >
          <Botega animate={STAGE_PROGRESS[stage] >= 75 ? "show" : "rest"} />
          <BotegaFlow animate={STAGE_PROGRESS[stage] >= 75 ? "show" : "rest"} />
          <Dexi animate={STAGE_PROGRESS[stage] >= 50 ? "show" : "rest"} />
        </Stack>
        <Typography variant="h6" fontWeight={300}>
          {STAGE_TITLES[stage]}...
        </Typography>
      </Stack>
    </>
  )
}
